import Dashboard from '@/views/Dashboard';
import CreateVenue from '@/components/CreateVenue';
import AllOrders from '@/views/AllOrders.vue';
import Order from '@/views/Order.vue';
import Menus from '@/views/Menus';
import SalesReports from '@/views/SalesReports';
import Webhooks from '@/views/Webhooks';
import Venues from '@/views/Venues';
import QRBuilder from '@/views/QRBuilder';
import Login from '@/views/Login';
import OAuthLogin from '@/views/OAuthLogin';
import OAuthConsent from '@/views/OAuthConsent';
import Signup from '@/views/Signup';
import CreateMenu from '@/components/CreateMenu';
import CreateMenuImport from '@/views/CreateMenuImport';
import EditMenu from '@/components/EditMenu';
import PasswordReset from '@/views/PasswordReset';
import Delivery from '@/components/reports/Delivery';
import Discounts from '@/views/Discounts';
import Offers from '@/views/Offers';
import CreateStory from '@/views/CreateStory';
import CreateEditDiscountCode from '@/components/CreateEditDiscountCode';
import CreateEditOffer from '@/components/CreateEditOffer';
import LiveOrders from '@/views/LiveOrders';
import Customer from '@/views/Customer';
import Customers from '@/views/Customers';
import ChangePassword from '@/views/ChangePassword';
import PrinterIntegration from '@/components/venue/settings/PrinterIntegration';
import SettingsContainer from '@/components/venue/settings/SettingsContainer';
import PrinterSettings from '@/components/venue/settings/PrinterSettings';
import StoreNotices from '@/components/venue/settings/StoreNotices';
import DeliveryZones from '@/components/venue/settings/DeliveryZones';
import OpeningHours from '@/components/venue/settings/OpeningHours';
import BrandingSettings from '@/components/venue/settings/BrandingSettings';
import BrandingUpsell from '@/components/venue/settings/BrandingUpsell';
import OrderAndPay from '@/components/venue/settings/OrderAndPay';
import Operations from '@/components/venue/settings/Operations';
import GeneralSettings from '@/components/venue/settings/GeneralSettings';
import PickupSlotSettings from '@/components/venue/settings/PickupSlotSettings';
import SettingsList from '@/components/venue/settings/SettingsList';
import FacebookSettings from '@/components/venue/settings/FacebookSettings';
import TipjarSettings from '@/components/venue/settings/TipjarSettings';
import OrkestroSettings from '@/components/venue/settings/OrkestroSettings';
import DeliverectSettings from '@/components/venue/settings/DeliverectSettings';
import ShipdaySettings from '@/components/venue/settings/ShipdaySettings';
import NashSettings from '@/components/venue/settings/NashSettings';
import FreshKdsSettings from '@/components/venue/settings/FreshKdsSettings';
import PaymentSettings from '@/components/venue/settings/PaymentSettings';
import FeedbackReports from '@/views/FeedbackReports';
import FeedbackOverview from '@/components/reports/FeedbackOverview';
import FeedbackSettings from '@/components/venue/settings/FeedbackSettings';
import TipSettings from '@/components/venue/settings/TipSettings';
import FeedbackAverage from '@/components/reports/FeedbackAverage';
import CreateAdyenAccount from '@/components/venue/settings/adyen/CreateAdyenAccount';
import ManageAdyenAccountHolder from '@/components/venue/settings/adyen/ManageAdyenAccountHolder';
import ConnectAdyenAccount from '@/components/venue/settings/adyen/ConnectAdyenAccount';
import ManageAdyenAccount from '@/components/venue/settings/adyen/ManageAdyenAccount';
// adyen platform
import CreateAdyenPlatformAccount from '@/components/venue/settings/adyenPlatform/CreateAdyenPlatformAccount';
import ManageAdyenPlatformAccountHolder from '@/components/venue/settings/adyenPlatform/ManageAdyenPlatformAccountHolder';
import ConnectAdyenPlatformAccount from '@/components/venue/settings/adyenPlatform/ConnectAdyenPlatformAccount';
import AirshipSettings from '@/components/venue/settings/AirshipSettings';
import CentegraSettings from '@/components/venue/settings/CentegraSettings';
import DeliverectConnectedSettings from '@/components/venue/settings/DeliverectConnectedSettings';
import InstagramSettings from '@/components/venue/settings/InstagramSettings';
import InstagramAuthResult from '@/components/venue/settings/InstagramAuthResult';
import Lightspeed from '@/views/Lightspeed';
import LightspeedSettings from '@/components/venue/settings/LightspeedSettings';
import ComtrexSettings from '@/components/venue/settings/ComtrexSettings';
import ToggleSettings from '@/components/venue/settings/ToggleSettings';
import PayAtTableList from '@/views/PayAtTableList';
import SmartReviews from '@/components/SmartReviews';
import PiggySettings from '@/components/venue/settings/PiggySettings';
import MenuImportSpreadsheet from '@/views/MenuImportSpreadsheet';
import ResourcesScreen from '@/views/ResourcesScreen';
import UpsellScreen from '@/views/UpsellScreen';
import DiscountImportSpreadsheet from '@/views/DiscountImportSpreadsheet';
import KlaviyoSettings from '@/components/venue/settings/KlaviyoSettings.vue';
import CaptiveWifiSettings from '@/components/venue/settings/CaptiveWifiSettings.vue';
import GoogleAnalyticsSettings from '@/components/venue/settings/GoogleAnalyticsSettings.vue';
import OpentableSettings from '@/components/venue/settings/OpentableSettings.vue';
import KitchenCutSettings from '@/components/venue/settings/KitchenCutSettings';
import TisslSettings from '@/components/venue/TisslSettings';
import AtreemoSettings from '@/components/venue/settings/AtreemoSettings';
import AutomationsSettings from '@/components/venue/settings/AutomationsSettings';
import GiftproSettings from '@/components/venue/settings/GiftproSettings';
import FeaturebaseSSO from '@/views/FeaturebaseSso';
import PedalMeSettings from '@/components/venue/settings/PedalMeSettings';
import ComoSettings from '@/components/venue/settings/ComoSettings';
import TranslationOverrides from '@/components/venue/settings/TranslationOverrides';
import { componentLoader } from '@/utils/componentLoader';
import UberDirectSettings from '@/components/venue/settings/UberDirectSettings';
import ZonalSettings from '@/components/venue/settings/ZonalSettings';
import TenzoSettings from "@/components/venue/settings/TenzoSettings.vue";
import StreamSettings from '@/components/venue/settings/StreamSettings.vue';
import SuperchatSettings from '@/components/venue/settings/SuperchatSettings.vue';
import FrontSettings from '@/components/venue/settings/FrontSettings.vue';
import TawktoSettings from '@/components/venue/settings/TawktoSettings.vue';
import CycloneSettings from '@/components/venue/settings/CycloneSettings.vue';

const StoreDesigner = componentLoader(() =>
    import(
        /* webpackChunkName: "store-designer" */ '@/components/venue/settings/StoreDesigner'
    )
);

const DemoStoreDesigner = componentLoader(() =>
    import(
        /* webpackChunkName: "demo-store-designer" */ '@/components/demo/DemoStoreDesigner'
    )
);

const AdyenTerms = componentLoader(() =>
    import('@/components/storekitPayments/AdyenTerms')
);
const OrdersDow = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/OrdersDow'
    )
);
const OrdersReport = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/Orders'
    )
);
const BlockedOrdersReport = componentLoader(() =>
    import(
        /* webpackChunkName: "logs-reports" */ '@/components/reports/FailedOrders.vue'
    )
);
const IntegrationErrorsReport = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/IntegrationErrors.vue'
    )
);
const LogsReports = componentLoader(() =>
    import(/* webpackChunkName: "sales-reports" */ '@/views/LogsReports.vue')
);
const FailedOrdersReport = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/FailedOrders.vue'
    )
);
const RevenueByTableArea = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/RevenueByTableArea'
    )
);
const OrdersTod = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/OrdersTod'
    )
);
const Products = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/Products'
    )
);
const Categories = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/Categories.vue'
    )
);
const AverageOrdeValue = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/AverageOrderValue'
    )
);
const TipsReport = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/TipsReport'
    )
);
const Z = componentLoader(() =>
    import(/* webpackChunkName: "sales-reports" */ '@/components/reports/Z')
);
const PaymentReports = componentLoader(() =>
    import(/* webpackChunkName: "payment-reports" */ '@/views/PaymentReports')
);
const AdyenBalanceReport = componentLoader(() =>
    import(
        /* webpackChunkName: "payment-reports" */ '@/components/reports/payments/AdyenBalance'
    )
);
const AdyenPayoutReport = componentLoader(() =>
    import(
        /* webpackChunkName: "payment-reports" */ '@/components/reports/payments/AdyenPayouts'
    )
);
const AdyenTransactionsByDayReport = componentLoader(() =>
    import(
        /* webpackChunkName: "transactions-reports" */ '@/components/reports/payments/AdyenTransactionsByDay'
    )
);
const AdyenAllTransactionsReport = componentLoader(() =>
    import(
        /* webpackChunkName: "transactions-reports" */ '@/components/reports/payments/AdyenAllTransactions'
    )
);
const AdyenTransfersReport = componentLoader(() =>
    import(
        /* webpackChunkName: "payment-reports" */ '@/components/reports/payments/AdyenTransfersReport'
    )
);
const FeeStatements = componentLoader(() =>
    import(
        /* webpackChunkName: "payment-reports" */ '@/components/reports/payments/FeeStatements'
    )
);
const DiscountsReport = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/DiscountsReport'
    )
);
const DiscountedOrdersReport = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/DiscountedOrdersReport'
    )
);
const RefundedOrdersReport = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/RefundedOrdersReport'
    )
);
const BatchStatistics = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/BatchStatistics'
    )
);
const VenueSnoozeReport = componentLoader(() =>
    import(
        /* webpackChunkName: "sales-reports" */ '@/components/reports/VenueSnoozeReport'
    )
);
// const CannyWidget = () => import('@/components/widgets/CannyWidget');

const FeaturebaseWidget = componentLoader(() =>
    import('@/components/widgets/FeaturebaseWidget')
);

const PreOrderPrepView = componentLoader(() =>
    import('@/views/PreOrderPrepView')
);

const OrderCalendarView = componentLoader(() =>
    import('@/views/OrderCalendarView')
);

const CateringView = componentLoader(() => import('@/views/CateringView'));

const ManageMenuAgGrid = componentLoader(() =>
    import('@/views/ManageMenuAgGrid')
);
const ManageVenuesAgGrid = componentLoader(() =>
    import('@/views/ManageVenuesAgGrid')
);
const ProductsView = componentLoader(() => import('@/views/Products'));
const EditProduct = componentLoader(() => import('@/views/EditProduct'));

const Analytics = componentLoader(() =>
    import(/* webpackChunkName: "analytics" */ '@/views/Analytics')
);

const routes = [
    {
        path: '/',
        redirect: 'dashboard',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            requiresAuth: false,
            requiresGuest: true
        }
    },
    {
        path: '/oauth-login',
        name: 'oauthLogin',
        component: OAuthLogin,
        meta: {
            requiresAuth: false,
            requiresGuest: false
        }
    },
    {
        path: '/oauth-consent',
        name: 'oauthConsent',
        component: OAuthConsent,
        meta: {
            requiresAuth: false,
            requiresGuest: false
        }
    },
    {
        path: '/signup',
        name: 'signup',
        component: Signup,
        meta: {
            requiresAuth: false,
            requiresGuest: true
        }
    },
    {
        path: '/signup/:referrerCode/',
        name: 'signupWithReferral',
        component: Signup,
        meta: {
            requiresAuth: false,
            requiresGuest: true
        }
    },
    {
        path: '/qr',
        name: 'qr',
        component: QRBuilder
    },
    {
        path: '/reset',
        name: 'reset',
        component: PasswordReset,
        meta: {
            requiresAuth: false
        },
        props: true
    },
    {
        path: '/change',
        name: 'change',
        component: ChangePassword,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/demo/store-designer',
        name: 'demoStoreDesigner',
        component: DemoStoreDesigner,
        meta: {
            requiresAuth: false,
            fullWidth: true,
            hideNav: true,
            hideToggleSidebar: true
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/stores',
        name: 'stores',
        component: Venues,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/multisite',
        name: 'multisite',
        component: ManageVenuesAgGrid,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/tables',
        name: 'tables',
        component: PayAtTableList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/resources',
        name: 'resources',
        component: ResourcesScreen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/live-tables',
        name: 'liveTables',
        component: PayAtTableList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/stores/create',
        name: 'createVenue',
        component: CreateVenue,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/adyen/account/:code',
        name: 'manageAdyenAccountHolderGlobal',
        component: ManageAdyenAccountHolder,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/adyen/platform/account/:code',
        name: 'manageAdyenPlatformAccountHolderGlobal',
        component: ManageAdyenPlatformAccountHolder,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/stores/edit/:id/',
        component: SettingsContainer,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'editVenue',
                component: SettingsList
            },
            {
                path: 'general',
                name: 'generalSettings',
                component: GeneralSettings
            },
            {
                path: 'notices',
                name: 'storeNoticeSettings',
                component: StoreNotices
            },
            {
                path: 'branding',
                name: 'brandingSettings',
                component: BrandingSettings
            },
            {
                path: 'custom-branding',
                name: 'brandingUpsell',
                component: BrandingUpsell
            },
            {
                path: 'hours',
                name: 'openingHoursSettings',
                component: OpeningHours
            },
            {
                path: 'operations',
                name: 'opeationsSettings',
                component: Operations
            },
            {
                path: 'zones',
                name: 'deliveryZonesSettings',
                component: DeliveryZones,
                meta: {
                    fullWidth: true,
                    hideNav: true
                }
            },
            {
                path: 'store-designer',
                name: 'storeDesigner',
                component: StoreDesigner,
                meta: {
                    fullWidth: true,
                    hideNav: true,
                    hideToggleSidebar: true
                }
            },
            {
                path: 'pre-orders',
                name: 'pickupSlotSettings',
                component: PickupSlotSettings
            },
            {
                path: 'order-and-pay',
                name: 'OrderAndPaySettings',
                component: OrderAndPay,
                meta: {
                    fullWidth: true
                }
            },
            {
                path: 'printers',
                name: 'printerIntegration',
                component: PrinterIntegration
            },
            {
                path: 'printers/settings',
                name: 'printerSettings',
                component: PrinterSettings,
                props: route => ({
                    selectedMac: route.query.mac,
                    operation: route.query.operation
                })
            },
            {
                path: 'facebook',
                name: 'facebookSettings',
                component: FacebookSettings
            },
            {
                path: 'opentable',
                name: 'opentableSettings',
                component: OpentableSettings
            },
            {
                path: 'google-analytics',
                name: 'googleAnalyticsSettings',
                component: GoogleAnalyticsSettings
            },
            {
                path: 'captive-wifi',
                name: 'captiveWifiSettings',
                component: CaptiveWifiSettings
            },
            {
                path: 'klaviyo',
                name: 'klaviyoSettings',
                component: KlaviyoSettings
            },
            {
                path: 'tipjar',
                name: 'tipjarSettings',
                component: TipjarSettings
            },
            {
                path: 'orkestro',
                name: 'orkestroSettings',
                component: OrkestroSettings
            },
            {
                path: 'epos',
                name: 'deliverectSettings',
                component: DeliverectSettings
            },
            {
                path: 'deliverect',
                name: 'deliverectConnectedSettings',
                component: DeliverectConnectedSettings
            },
            {
                path: 'shipday',
                name: 'shipdaySettings',
                component: ShipdaySettings
            },
            {
                path: 'nash',
                name: 'nashSettings',
                component: NashSettings
            },
            {
                path: 'freshkds',
                name: 'freshkdsSettings',
                component: FreshKdsSettings
            },
            {
                path: 'tissl',
                name: 'tisslSettings',
                component: TisslSettings
            },
            {
                path: 'payments',
                name: 'paymentSettings',
                component: PaymentSettings
            },
            {
                path: 'feedback',
                name: 'feedbackSettings',
                component: FeedbackSettings
            },
            {
                path: 'automations',
                name: 'automationsSettings',
                component: AutomationsSettings
            },
            {
                path: 'tips',
                name: 'tipSettings',
                component: TipSettings
            },
            {
                path: 'account/create',
                name: 'createAdyenAccount',
                component: CreateAdyenAccount
            },
            {
                path: 'account/connect',
                name: 'connectAdyenAccount',
                component: ConnectAdyenAccount
            },
            {
                path: 'account/manage',
                name: 'mangeAdyenAccount',
                component: ManageAdyenAccount
            },
            {
                path: 'account/:code/status',
                name: 'manageAdyenAccountHolder',
                component: ManageAdyenAccountHolder
            },
            // adyen platform
            {
                path: 'account/platform/create',
                name: 'createAdyenPlatformAccount',
                component: CreateAdyenPlatformAccount
            },
            {
                path: 'account/platform/:accountHolderId/create',
                name: 'manageAdyenPlatformAccountHolder',
                component: ManageAdyenPlatformAccountHolder
            },
            {
                path: 'account/platform/connect',
                name: 'connectAdyenPlatformAccount',
                component: ConnectAdyenPlatformAccount
            },
            {
                path: 'airship',
                name: 'airshipSettings',
                component: AirshipSettings
            },
            {
                path: 'centegra',
                name: 'centegraSettings',
                component: CentegraSettings
            },
            {
                path: 'instagram',
                name: 'instagramSettings',
                component: InstagramSettings
            },
            {
                path: 'instagram/auth-result',
                name: 'instagramAuthResult',
                component: InstagramAuthResult
            },
            {
                path: 'lightspeed',
                name: 'lightspeedSettings',
                component: LightspeedSettings
            },
            {
                path: 'comtrex',
                name: 'comtrexSettings',
                component: ComtrexSettings
            },
            {
                path: 'toggle',
                name: 'toggleSettings',
                component: ToggleSettings
            },
            {
                path: 'piggy',
                name: 'piggySettings',
                component: PiggySettings
            },
            {
                path: 'kitchen-cut',
                name: 'kitchenCutSettings',
                component: KitchenCutSettings
            },
            {
                path: 'atreemo',
                name: 'atreemoSettings',
                component: AtreemoSettings
            },
            {
                path: 'giftpro',
                name: 'giftproSettings',
                component: GiftproSettings
            },
            {
                path: 'pedalme',
                name: 'pedalMeSettings',
                component: PedalMeSettings
            },
            {
                path: 'como',
                name: 'comoSettings',
                component: ComoSettings,
                meta: {
                    requiresAuth: true
                }
            },
                        {
                            path: 'uber-direct',
                            name: 'uberDirectSettings',
                            component: UberDirectSettings
                        },
                        {
                            path: 'cyclone',
                            name: 'cycloneSettings',
                            component: CycloneSettings
                        },
                        {
                            path: 'pointone',
                name: 'pointOneSettings',
                component: () =>
                    import('@/components/venue/settings/PointOneSettings')
            },
            {
                path: 'translation-overrides',
                name: 'translationOverrides',
                component: TranslationOverrides,
                meta: {
                    fullWidth: true,
                    hideNav: true
                }
            },
            {
                path: 'tenzo',
                name: 'tenzoSettings',
                component: TenzoSettings,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'zonal',
                name: 'zonalSettings',
                component: ZonalSettings,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'stream',
                name: 'streamSettings',
                component: StreamSettings
            },
            {
                path: 'superchat',
                name: 'superchatSettings',
                component: SuperchatSettings,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'front',
                name: 'frontSettings',
                component: FrontSettings,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'tawkto',
                name: 'tawktoSettings',
                component: TawktoSettings,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/customers',
        name: 'customers',
        component: Customers,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/customers/:email',
        name: 'customerDetail',
        component: Customer,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/orders',
        name: 'orders',
        component: AllOrders,
        meta: {
            requiresAuth: true,
            section: 'orders'
        }
    },
    {
        path: '/live-orders/:id?',
        name: 'liveOrders',
        component: LiveOrders,
        meta: {
            requiresAuth: true,
            section: 'orders'
        }
    },
    {
        path: '/prep',
        name: 'preOrderPrep',
        component: PreOrderPrepView,
        meta: {
            requiresAuth: true,
            section: 'orders'
        }
    },
    {
        path: '/calendar',
        name: 'orderCalendar',
        component: OrderCalendarView,
        meta: {
            requiresAuth: true,
            section: 'orders'
        }
    },
    {
        path: '/catering',
        name: 'cateringView',
        component: CateringView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/orders/:id',
        name: 'orderDetail',
        component: Order,
        meta: {
            requiresAuth: true,
            section: 'orders'
        }
    },
    {
        path: '/menus',
        name: 'menus',
        component: Menus,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/menus/:venueId/create',
        name: 'createMenu',
        component: CreateMenu,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/menus/:venueId/import',
        name: 'createMenuImport',
        component: CreateMenuImport,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/menus/:venueId/import/spreadsheet',
        name: 'menuImportSpreadsheet',
        component: MenuImportSpreadsheet,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/import/success',
        name: 'menu',
        component: CreateMenuImport,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/menus/:id/edit',
        name: 'editMenu',
        component: EditMenu,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/menus/:id/manage',
        name: 'manageMenu',
        component: ManageMenuAgGrid,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/discounts',
        name: 'discounts',
        component: Discounts,
        meta: {
            requiresAuth: true,
            section: 'marketing'
        }
    },
    {
        path: '/products',
        name: 'products',
        component: ProductsView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/products/:id',
        name: 'editProduct',
        component: EditProduct,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/banners',
        name: 'offers',
        component: Offers,
        meta: {
            requiresAuth: true,
            section: 'marketing'
        }
    },
    {
        path: '/stories',
        redirect: { name: 'offers' }
    },
    {
        path: '/stories/new',
        name: 'createStory',
        component: CreateStory,
        meta: {
            requiresAuth: true,
            section: 'marketing'
        }
    },
    {
        path: '/stories/:id/edit',
        name: 'editStory',
        component: CreateStory,
        meta: {
            requiresAuth: true,
            section: 'marketing'
        }
    },
    {
        path: '/discounts/import',
        name: 'discountsImport',
        component: DiscountImportSpreadsheet,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/discounts/new',
        name: 'newDiscount',
        component: CreateEditDiscountCode,
        meta: {
            requiresAuth: true,
            section: 'marketing'
        }
    },
    {
        path: '/discounts/:id',
        name: 'editDiscount',
        component: CreateEditDiscountCode,
        meta: {
            requiresAuth: true,
            section: 'marketing'
        }
    },
    {
        path: '/banners/new',
        name: 'newOffer',
        component: CreateEditOffer,
        meta: {
            requiresAuth: true,
            section: 'marketing'
        }
    },
    {
        path: '/banners/:id',
        name: 'editOffer',
        component: CreateEditOffer,
        meta: {
            requiresAuth: true,
            section: 'marketing'
        }
    },
    {
        path: '/reports/sales',
        name: 'salesReports',
        component: SalesReports,
        meta: {
            requiresAuth: true,
            section: 'reports'
        },
        children: [
            {
                path: 'orders',
                name: 'ordersReport',
                component: OrdersReport
            },
            {
                path: 'revenue-by-table-area',
                name: 'revenueByTableArea',
                component: RevenueByTableArea
            },
            {
                path: 'orders-dow',
                name: 'dowReport',
                component: OrdersDow
            },
            {
                path: 'orders-tod',
                name: 'todReport',
                component: OrdersTod
            },
            {
                path: 'products',
                name: 'productsReport',
                component: Products
            },
            {
                path: 'categories',
                name: 'categoriesReport',
                component: Categories
            },
            {
                path: 'delivery',
                name: 'deliveryReport',
                component: Delivery
            },
            {
                path: 'z',
                name: 'zReport',
                component: Z
            },
            {
                path: 'tips',
                name: 'tipsReports',
                component: TipsReport
            },
            {
                path: 'average-order',
                name: 'averageOrderValueReport',
                component: AverageOrdeValue
            },
            {
                path: 'discounts',
                name: 'discountsReports',
                component: DiscountsReport
            },
            {
                path: 'discounted-orders',
                name: 'discountedOrdersReport',
                component: DiscountedOrdersReport
            },
            {
                path: 'refunded-orders',
                name: 'refundedOrdersReport',
                component: RefundedOrdersReport
            },
            {
                path: 'batch-statistics',
                name: 'batchStatisticsReport',
                component: BatchStatistics
            },
            {
                path: 'integration-errors',
                name: 'integrationErrorsReport',
                component: IntegrationErrorsReport
            },
            {
                path: 'failed-orders',
                name: 'failedOrdersReport',
                component: FailedOrdersReport
            },
            {
                path: 'venue-snooze',
                name: 'venueSnoozeReport',
                component: VenueSnoozeReport
            }
        ]
    },
    {
        path: '/feedback',
        name: 'feedbackReports',
        component: FeedbackReports,
        meta: {
            requiresAuth: true,
            section: 'reports'
        },
        children: [
            {
                path: 'overview',
                name: 'feedbackOverview',
                component: FeedbackOverview
            },
            {
                path: 'average',
                name: 'feedbackAverage',
                component: FeedbackAverage
            }
        ]
    },
    {
        path: '/smart-reviews',
        name: 'smartReviews',
        component: SmartReviews,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/analytics',
        name: 'analytics',
        component: Analytics,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/upgrade',
        name: 'upgrade',
        beforeEnter: () => {
            window.location.href =
                'https://t09czsyu90l.typeform.com/to/gMpZl4lZ';
        },
        component: UpsellScreen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/reports/payments',
        name: 'paymentReports',
        component: PaymentReports,
        meta: {
            requiresAuth: true,
            section: 'reports'
        },
        children: [
            {
                path: 'balance',
                name: 'adyenBalanceReport',
                component: AdyenBalanceReport
            },
            {
                path: 'payouts',
                name: 'adyenPayoutReport',
                component: AdyenPayoutReport
            },
            {
                path: 'transactions-by-day',
                name: 'adyenTransactionsByDayReport',
                component: AdyenTransactionsByDayReport
            },
            {
                path: 'transactions-all',
                name: 'adyenAllTransactionsReport',
                component: AdyenAllTransactionsReport
            },
            {
                path: 'payouts-new',
                name: 'adyenTransfersReport',
                component: AdyenTransfersReport
            },
            {
                path: 'fee-statements',
                name: 'feeStatementsReport',
                component: FeeStatements
            }
        ]
    },
    {
        path: '/logs',
        name: 'logReports',
        component: LogsReports,
        meta: {
            requiresAuth: true,
            section: 'reports'
        },
        children: [
            {
                path: 'pos',
                name: 'posIntegrationErrorsReport',
                component: IntegrationErrorsReport
            },
            {
                path: 'blocked-orders',
                name: 'blockedOrdersReport',
                component: BlockedOrdersReport
            }
        ]
    },
    {
        path: '/developers/webhooks',
        name: 'webhooks',
        component: Webhooks,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/developers/api-keys',
        name: 'api-keys',
        component: () => import('@/components/settings/ApiKeySettings.vue')
    },
    {
        path: '/settings',
        component: () => import('@/components/settings/SettingsContainer.vue'),
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                redirect: { name: 'settings-profile' }
            },
            {
                path: 'profile',
                name: 'settings-profile',
                component: () =>
                    import('@/components/settings/ProfileSettings.vue')
            },
            {
                path: 'account',
                name: 'settings-account',
                component: () =>
                    import('@/components/settings/AccountSettings.vue')
            },
            {
                path: 'members',
                name: 'settings-members',
                component: () =>
                    import('@/components/settings/MembersSettings.vue')
            },
            {
                path: 'developers',
                name: 'settings-developers',
                component: () =>
                    import('@/components/settings/DevelopersSettings.vue')
            }
        ]
    },
    {
        path: '/settings/customisation',
        component: () =>
            import('@/components/customisation/CustomisationContainer.vue'),
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: 'customisationList',
                component: () =>
                    import(
                        '@/components/customisation/CustomisationList.vue'
                    )
            },
            {
                path: 'notifications',
                name: 'notificationTemplates',
                component: () => import('@/views/NotificationTemplates.vue')
            },
            {
                path: 'notifications/new',
                name: 'newNotificationTemplate',
                component: () =>
                    import('@/components/CreateEditNotificationTemplate.vue')
            },
            {
                path: 'notifications/:id/edit',
                name: 'editNotificationTemplate',
                component: () =>
                    import('@/components/CreateEditNotificationTemplate.vue')
            }
        ]
    },

    {
        path: '/auth/lightspeed',
        name: 'lightspeedAuth',
        component: Lightspeed,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/storekit-payments/terms',
        name: 'storeKitPaymentsTerms',
        component: AdyenTerms,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/feature-requests',
        name: 'feedback',
        component: FeaturebaseWidget,
        meta: {
            requiresAuth: true,
            featureBasePage: 'Board'
        }
    },
    {
        path: '/feature-requests/*',
        component: FeaturebaseWidget,
        meta: {
            requiresAuth: true,
            featureBasePage: 'Board'
        }
    },
    {
        path: '/release-notes',
        name: 'releaseNotes',
        component: FeaturebaseWidget,
        meta: {
            requiresAuth: true,
            featureBasePage: 'Changelog'
        }
    },
    {
        path: '/release-notes/*',
        component: FeaturebaseWidget,
        meta: {
            requiresAuth: true,
            featureBasePage: 'Changelog'
        }
    },
    {
        path: '/sso/featurebase',
        name: 'featurebaseSSO',
        component: FeaturebaseSSO,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/message-hub',
        name: 'dittofeed',
        component: () => import('@/views/MessageHub.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'dittofeedStart',
                meta: {
                    requiresAuth: true,
                    path: 'start'
                }
            },
            {
                path: 'templates',
                name: 'dittofeedTemplates',
                meta: {
                    requiresAuth: true,
                    path: 'templates'
                }
            },
            {
                path: 'segments',
                name: 'dittofeedSegments',
                meta: {
                    requiresAuth: true,
                    path: 'segments'
                }
            },
            {
                path: 'broadcasts',
                name: 'dittofeedBroadcasts',
                meta: {
                    requiresAuth: true,
                    path: 'broadcasts'
                }
            },
            {
                path: 'deliveries',
                name: 'dittofeedDeliveries',
                meta: {
                    requiresAuth: true,
                    path: 'deliveries'
                }
            }
        ]
    }
];

export default routes;
